import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import EmailVerified from './EmailVerified';
import { useHandleEmailVerification } from '../../../../hooks/useHandleEmailVerification';
import { useHistory } from 'react-router';
import { getSnowplowDuid } from '../../../analytics/Snowplow';
import { getPostLoginRedirectRoute } from '../../../../constants/Routes';
import useOnboardingTracking from '../../../../hooks/useOnboardingTracking';

const EmailVerifiedContainer = () => {
	const gigyaUser = useSelector((state) => state.authentication.gigyaUser);
	const history = useHistory();
	useOnboardingTracking();

	const { isVerified } = useHandleEmailVerification();
	const gigyaRedirectUrl = gigyaUser?.data?.redirectUrl;
	const gigyaUserData = gigyaUser?.data;

	useEffect(() => {
		const snowplowDuid = getSnowplowDuid();

		if (
			gigyaUser.data?.snowplow?.domain_sessionid &&
			gigyaUser.data?.snowplow?.domain_sessionid !== snowplowDuid?.domain_sessionid
		) {
			history.replace({
				...location,
				search: `_sp=${gigyaUser.data.snowplow.domain_userid}.${gigyaUser.data.snowplow.time_previous_session}.${gigyaUser.data.snowplow.domain_sessionid}`,
			});
		}

		if (isVerified && gigyaUserData) {
			if (gigyaRedirectUrl) {
				window.location.href = `${window.location.origin}${gigyaRedirectUrl}`;
				return;
			} else {
				window.location.href = `${window.location.origin}${getPostLoginRedirectRoute()}`;
			}
		}
	}, [isVerified, gigyaUserData, gigyaRedirectUrl, history]);

	return (
		<EmailVerified
			gigyaUser={gigyaUser}
			gigyaRedirectUrl={gigyaRedirectUrl}
			isPending={!!(!isVerified || !gigyaUserData || gigyaRedirectUrl)}
		/>
	);
};

export default EmailVerifiedContainer;
